import { useApolloClient } from "@apollo/client";
import {
  COMPANY_PROFILE_ROW_COUNT_QUERY,
  CompanyProfileRowCountCheckResponse,
} from "../../../legacy/queries/Companies";
import type {
  InstallFilters,
  IntentFilters,
} from "../../../store/companyPageStore";
import { COMPANY_SEARCH_CLIENT } from "../../../utils/consts";
import {
  transformInstallFiltersToInstallExportParams,
  transformIntentFiltersToIntentExportParams,
} from "../components/CompanyExport/transformCompanyPageFiltersToExportParams";

interface Props {
  hgId: string;
  install: InstallFilters;
  intent: IntentFilters;
}

export interface RowCountData {
  faiRowCount: number;
  installsRowCount: number;
  intentRowCount: number;
}

export const useCompanyProfileRowCount = (props: Props) => {
  const { install, intent, hgId } = props;

  const client = useApolloClient();

  const fetchRowCountData = async (): Promise<RowCountData> => {
    try {
      const { data } = await client.query<CompanyProfileRowCountCheckResponse>({
        query: COMPANY_PROFILE_ROW_COUNT_QUERY,
        variables: {
          hgId,
          install: {
            filters: transformInstallFiltersToInstallExportParams(install),
            includeCorporateDescendants: install.includeCorporateDescendants,
          },
          intent: {
            filters: transformIntentFiltersToIntentExportParams(intent),
            includeCorporateDescendants: intent.includeCorporateDescendants,
          },
        },
        context: { clientName: COMPANY_SEARCH_CLIENT },
        fetchPolicy: "no-cache",
      });

      const rowCountData = data?.companyProfileRowCountCheck?.data;

      return {
        faiRowCount: rowCountData?.faiRowCount || 0,
        installsRowCount: rowCountData?.installsRowCount || 0,
        intentRowCount: rowCountData?.intentRowCount || 0,
      };
    } catch (error) {
      console.error("Failed to fetch company profile row count data", error);

      return { faiRowCount: 0, installsRowCount: 0, intentRowCount: 0 };
    }
  };

  return { fetchRowCountData };
};
